<template>
  <div>
    <el-row class="search-add" :gutter="10">
      <el-col :span="4">
        <el-input placeholder="出库编号" v-model="outBillNo"></el-input>
      </el-col>
      <el-col :span="4">
        <el-input placeholder="服务编号" v-model="batchCode"></el-input>
      </el-col>
      <el-col :span="4">
        <el-input placeholder="设备编号" v-model="deviceCode"></el-input>
      </el-col>
      <el-col :span="4">
        <el-input placeholder="机构名称" v-model="referName"></el-input>
      </el-col>
      <el-col :span="4">
        <el-button type="primary" icon="el-icon-search" @click="search"
          >搜索</el-button
        >
      </el-col>
      <el-col :span="2">
        <router-link to="./add">
          <el-button type="success">新增</el-button>
        </router-link>
      </el-col>
    </el-row>

    <el-table :data="data" border stripe style="width: 100%">
      <el-table-column prop="outBillNo" label="出库编号"> </el-table-column>
      <el-table-column prop="batchCode" label="服务编号"> </el-table-column>
      <el-table-column prop="referName" label="机构名称"> </el-table-column>
      <el-table-column prop="recipientName" label="收件人姓名">
      </el-table-column>
      <el-table-column prop="recipientPhone" label="收件人电话">
      </el-table-column>
      <el-table-column prop="recipientNote" label="收货地址"> </el-table-column>
      <el-table-column prop="deliveryWay" label="快递公司">
        <template slot-scope="scope">
          <div v-if="scope.row.deliveryWay === '自提'"></div>
          <div v-if="scope.row.deliveryWay !== '自提'">
            {{ scope.row.deliveryWay }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="deliveryCode" label="快递单号"> </el-table-column>
      <el-table-column prop="deliveryUrl" label="快递截图">
        <template slot-scope="scope">
          <div v-if="!!scope.row.deliveryUrl === false">-</div>
          <div v-if="!!scope.row.deliveryUrl === true">
            <el-image
              style="width: 100px; height: 100px"
              :src="scope.row.deliveryUrl"
              :preview-src-list="[scope.row.deliveryUrl]"
            >
            </el-image>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="personalName" label="自提姓名"> </el-table-column>
      <el-table-column prop="personalPhone" label="自提电话"> </el-table-column>
      <el-table-column prop="personalNote" label="自提备注"> </el-table-column>
      <el-table-column fixed="right" label="操作">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="Edit(scope.row)"
            >编辑</el-button
          >
          <el-button type="text" size="small" @click="onload(scope.row)"
            >下载明细</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <div class="tableDel-Page">
      <Pagination :params="pagin" @pageBind="getList"></Pagination>
    </div>
  </div>
</template>

<script>
import Pagination from "@/components/Pagination";
export default {
  name: "admin",
  data() {
    return {
      outBillNo: "",
      batchCode: "",
      deviceCode: "",
      referName: "",
      data: [],
      pagin: {
        pageNum: 1,
        pageSize: 20,
        total: 0,
      },
    };
  },
  methods: {
    search() {
      //搜索
      this.pagin.pageNum = 1;
      this.getList();
    },
    getList() {
      //数据绑定
      let params = {
        pageNum: this.pagin.pageNum,
        pageSize: this.pagin.pageSize,
      };
      if (this.outBillNo.trim() != "") {
        params.outBillNo = this.outBillNo;
      }
      if (this.deviceCode.trim() != "") {
        params.deviceCode = this.deviceCode;
      }
      if (this.batchCode.trim() != "") {
        params.batchCode = this.batchCode;
      }
      if (this.referName.trim() != "") {
        params.referName = this.referName;
      }
      this.$http.post("/manage/outBill/page", params).then((results) => {
        this.data = results["data"]["data"]["records"];
        this.pagin.total = results["data"]["data"]["total"];
      });
    },
    Edit(data) {
      this.$store.commit("setEditInfo", data);
      this.$router.push("./edit/" + data.id);
    },
    onload(data) {
      this.$http
        .get(`/manage/outBill/export_devices/${data.outBillNo}`)
        .then((res) => {
          const url = res.data.data.download_url;
          if (url) {
            const link = document.createElement("a");
            link.href = url;
            link.download = "";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          }
        });
    },
  },
  components: { Pagination },
};
</script>
